<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <div v-if="getLanguageChanged">{{refresh()}}</div>
        
        <v-card class="shadow-none" v-if="$store.getters.getLanguageList">     
            <div v-if="getShowHelpEvent">{{showHelp()}}</div>
            <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
            <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>
            <div v-if="needInit">{{initData()}}</div> 
            <div v-if="myContent">
                <div v-html="myContent.content">
                </div>
                <v-text-field v-model="myAnswer" filled color="styleObject.color" @change="styleObject.color = 'black'; feedback = '';">                    
                </v-text-field>                  
                <p v-if="feedback" v-bind:style="styleObject">{{feedback}}</p>  
            </div>
        </v-card>

        <v-card class="shadow-none" v-if="showMyHelp">
            <div v-html="myContent.help">
            </div>
            <v-btn @click="showMyHelp = false">Hide Help</v-btn>
        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'

export default {   
    data() {
        return {
                myContent:  {
                    content: 'loading...',
                    help: 'loading...',
                    answer_list : [{
                        answer : 'loading...',
                        feedback: 'loading...'
                    }]
                },
                myAnswer : null,
                myGlobals: null,
                feedback: null,
                showMyHelp: false,
                needInit : false,
                styleObject: {
                    color: 'black',
                }

        }
    },
    computed: 
        mapGetters([
                    'getShowHelpEvent',
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    'getLanguagePrimary',
                    'getLanguageChanged'
                    ])
    ,    
    props: { 
        dcontent: Object
    },
    methods: {
        initData() {
            this.needInit = false  
            this.$store.commit('setFeedback', null)   
            this.myContent = JSON.parse(this.dcontent.data.content)
            this.myGlobals = JSON.parse(this.dcontent.data.globals)
        },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent', false)
            for(var i = 0; i < this.myGlobals.ratings.length; i++) {
                if (this.myAnswer == this.myContent.answer_list[i].answer) {
                    this.feedback = this.myContent.answer_list[i].feedback
                    if (this.myGlobals.ratings[i] == 100) {
                        if (this.myContent.answer_list[i].feedback == '') this.feedback = 'Correct!'
                        this.styleObject.color = 'green'
                    }
                    if (this.myGlobals.ratings[i] < 100 && this.myGlobals.ratings[i] > 0) this.styleObject.color = 'orange'
                    return
                }
            }
            this.styleObject.color = 'red'
            this.feedback = "Sorry, bad answer."
        },
        showAnswer() {
            this.$store.commit('setShowAnswerEvent', false)
            for(var i = 0; i < this.myGlobals.ratings.length; i++) {
                if (this.myGlobals.ratings[i] == 100) {
                    this.myAnswer = this.myContent.answer_list[i].answer
                    this.feedback = this.myContent.answer_list[i].feedback
                    this.checkAnswer()
                    return
                }
            }
            
        },
        showHelp() {
            this.$store.commit('setShowHelpEvent', false)
            this.showMyHelp = true
        },
        refresh() {
            this.$store.commit('setLanguageChanged',false)
            this.initData()
        }
    },
    mounted() {
        this.needInit = true
    }
}
</script>

<style>

</style>